module.exports = __webpack_public_path__ + "assets/img/00195.429e3655.png";